export default __webpack_public_path__ + "static/media/biboo.4e005e17.png";